import React from 'react';
import "./DocumentGrid.scss";
import { Container, Grid } from "@mui/material";

import DocumentCard from 'components/DocumentDisplay/DocumentCard';

const DocumentGrid = ({ documents }) => {

    return (
        <Container id="document-grid">
            <Grid container spacing={1} className="search-result">
                {documents?.map((document) => {
                    return (
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <DocumentCard
                                key={document.id}
                                document={document}
                            />
                        </Grid>
                    );
                })}
            </Grid>
        </Container>
    );
};

export default DocumentGrid;
